'use strict';

var cookies = require('doc-cookies');
var listen = require('event-listener');
var merge = require('lodash.merge');
var once = require('lodash.once');
var postRobot = require('post-robot');

var constants = require('./constants');
var css = require('./css');
var device = require('./device');
var dom = require('./dom');
var buttonGenerator = require('./gen-button');
var guid = require('./guid');
var IframeFactory = require('./iframes');
var lightbox = require('./lightbox');
var Mask = require('./mask');
var redirect = require('./redirect');
var XoEmitter = require('./xo-emitter');

var blocker = require('./util/blocker');
var _log = require('./util/log');
var ready = require('./util/ready');
var removePanels = require('./util/remove-panels');
var loadScript = require('./util/script-loader');
var getECToken = require('./util/token-from-url');
var ownPropertyShim = require('./util/own-property-shim'); // ie hacks for same-origin

require('./shim');
(function() {
    /** PRIVATE **/

    var paypal = paypal || {};

    if (window.paypal && window.paypal.checkout) {
        _log(constants.ERROR_MESSAGES.PAYPAL_GLOBAL_OVERRIDE);
        return;
    }

    (function() {
        function addToNamespace(obj) {
            var namespace = window.PAYPAL || {};
            namespace.apps = namespace.apps || {};
            namespace.apps.Checkout = namespace.apps.Checkout || {};

            for (var prop in obj) {
                namespace.apps.Checkout[prop] = obj[prop];
            }

            // (Backwards compatibility) Setting up aliases for convenience
            namespace.checkout = namespace.apps.Checkout;

            // Export "PAYPAL" and "paypal" as globals
            window.PAYPAL = window.paypal = namespace;
        }

        /**
         * Creates an instance of the in-context MiniBrowser UI
         * @param {Object} userConfig Overrides to the default configuration
         */
        paypal.checkout = (function() {
            var xoEmitter = new XoEmitter();
            var app = {},
                config = {
                    name: constants.MINI_BROWSER_NAME, // This is eventually changed to something like: PPFrame1a2b3c4d5e, etc.
                    css: '$STYLES$',
                    secureWindow: constants.CONTENT_SECURE_WINDOW, // This can be modified by the parent app
                    continueLink: constants.CONTINUE_LINK,
                    locale: constants.DEFAULT_LOCALE, // This can be modified by the parent app
                    trigger: null,
                    isSmartPhone: false,
                    isWebView: false,
                    merchantID: null,
                    showMiniB: true,
                    sandBox: false,
                    devMode: false,
                    version: '3.0',
                    log: true,
                    cookiedExp: cookies.getItem('PPXOEXP'),
                    debug: cookies.getItem('PPDEBUG'),
                    domain: cookies.getItem('PPDOMAIN'),
                    urlPrefix: cookies.getItem('PPURLPREFIX'),
                    oldIe: navigator.userAgent.match(/MSIE [87]\./i),
                    // IE can only postmessage from window to iframe
                    needsIframeBridge: !!navigator.userAgent.match(/MSIE|trident|edge/i),
                    prefetchLoaded: false,
                    cookieCheckLoaded: false,
                    currentAgent: device.getAgent(),
                    merchantConfig: null,
                    guid: null,
                    enableOneTouch: true,
                    bodyStyle: null,
                    oneTouchEnabled: false,
                    thirdPartyCookiesEnabled: false,
                    forceLightboxDisabled: false,
                    lightboxOpened: false,
                    popupOpened: false
                },
                requireBtnJs = false,
                btnList = [],
                isOpen = false,
                errMsg = '', // eslint-disable-line no-unused-vars
                ecToken = null,
                jsBtnConfigs = [],
                setupCalled = false,
                oneTouchShowed = false,
                // blocker = null,
                mask = null,
                merchantServiceUrl = null,
                listeners = [];

            app.urlPrefix = '';

            function formatStatus(statusMessage, buttonCount, hasOneTouch) {
                if (buttonCount > 0) {
                    statusMessage += '_JS';
                }
                if (hasOneTouch) {
                    statusMessage += '_ONETOUCH';
                }
                return statusMessage;
            }

            /**
             * Tracking various events
             * @param {object} msg to send via beacon
             * @returns {null}
             */
            function _track(msg, isError) {
                var url = config.sandBox ? constants.SANDBOX_URL_ROOT : constants.LIVE_URL_ROOT,
                    msgStr;

                if (config.log && typeof msg === 'object') {
                    merge(msg, {
                        merchantSite: document.domain,
                        version: config.version,
                        token: ecToken,
                        guid: config.guid,
                        oneTouchShowed: oneTouchShowed.toString(),
                        jsBtnConfig: jsBtnConfigs,
                        status: formatStatus(msg.status, jsBtnConfigs.length, oneTouchShowed)
                    });

                    msgStr = encodeURIComponent(JSON.stringify(msg));
                    url = url + '/webapps/' + (config.merchantConfig.app || 'hermes') + '/api/log?event=' + msg.status +
                        '&state=merchant_incontext&token=' + (ecToken ? ecToken : 'undefined') // token='undefined' for FEEL logging
                        +
                        '&level=' + (isError ? 'error' : 'info') +
                        '&cb=' + Date.now() +
                        '&msg=' + msgStr;

                    var beacon = new Image();
                    beacon.src = url;

                    if (config.debug) {
                        _log(decodeURIComponent(msgStr));
                    }
                }
            }

            function callNewSetup() {
                var oldButtonEl = document.querySelectorAll('[data-paypal-button]'),
                    sandboxEl = document.querySelectorAll('[data-paypal-sandbox]'),
                    merchantIdEl = document.querySelectorAll('[data-paypal-id]');

                // Don't construct setup call if merchant doesn't have any old configuration
                if (oldButtonEl.length || sandboxEl.length || merchantIdEl.length) {
                    var oldButtons = oldButtonEl.length ? oldButtonEl : [],
                        environment = sandboxEl.length ? 'sandbox' : 'production',
                        merchantId = merchantIdEl.length ? merchantIdEl[0].getAttribute('data-paypal-id') : document.domain;

                    paypal.checkout.setup(merchantId, {
                        environment: environment,
                        button: oldButtons
                    });

                    _track({
                        status: 'IC_CUSTOM_BUTTON_SCAN'
                    });

                }
            }

            // Function call for data-paypal-button
            if (typeof window.paypalCheckoutReady !== 'function') {
                ready(callNewSetup);
            }

            function _removePanelsIfSamePage(conf) {
                // From startFlow or single page apps with # cancel urls
                if (conf.fromStartFlow || window.location.href.split('#')[0] === conf.cancelUrl.split('#')[0]) {
                    removePanels(conf);
                }
            }

            function _doReturn(conf) {
                _track({
                    status: 'IC_DESTROY_TO_RETURN_URL'
                });

                if (conf.fromStartFlow) {
                    if (isOpen) {
                        removePanels(conf);
                    }
                }

                if (!conf.async) {
                    return redirect(window, conf.returnUrl);
                }
            }

            function _doCancel(conf) {
                _track({
                    status: 'IC_DESTROY_TO_CANCEL_URL'
                });

                _removePanelsIfSamePage(conf);

                if (!conf.async) {
                    return redirect(window, conf.cancelUrl);
                }
            }

            function _closeWindow(win) {
                if (win && win.close) {
                    win.close();
                }
            }

            /**
             * Clear body class of the merchant website when user closes lightbox/miniBrowser / returns back to the merchant
             * @param {string} className which is equal to the Mini browser name, e.g PPFrameac5f5777
             */
            function _clearBodyIframeClass(className) {
                document.body.className = document.body.className.replace(className, '');
            }

            /**
             * Remove all the events for an instance
             */
            function _removeEvents() {
                for (var i = 0; i < listeners.length; i++) {
                    listeners[i].remove();
                }
                blocker.unblock();
            }

            /**
             * Custom event which does some cleanup: all UI DOM nodes and custom events
             * are removed from the current page
             *
             * @param {Event} e The event object
             */
            var _destroy = once(function (event) {
                _clearBodyIframeClass(config.name);

                var wrapper = document.getElementById(config.name);

                if (app.heartbeat) {
                    // To avoid double refresh triggering from timeout loop
                    clearTimeout(app.heartbeat);
                }

                if (app.windowAccessCrash) {
                    // don't destroy if the window crashed out
                    return;
                }

                // If the lightbox is open, transition it out and remove it.
                if (config.lightboxOpened && !config.popupOpened) {
                    lightbox.destroy(app, config, function() {
                        _removeEvents();
                        isOpen = false;

                        _closeWindow(app.win);

                        if (config.returnUrl) {
                            _doReturn(config);
                        } else {
                            _doCancel(config);
                        }
                    });
                    xoEmitter.emit('cancel', {
                        returnUrl: config.cancelUrl
                    });
                    return;
                }

                if (isOpen && wrapper && wrapper.parentNode) {
                    // Update the content from the post message response
                    // var msg = document.querySelector('#PPFrame .message');
                    var msg = document.querySelector('#' + config.name + ' .message');
                    if (msg && config.cancelUrl) {
                        msg.innerHTML = constants.CONTENT_LOADING;

                        if (!config.returnUrl) {
                            _track({
                                status: 'IC_DESTROY_TO_CANCEL_URL'
                            });

                            // From startFlow or single page apps with # cancel urls
                            var probablySinglePageApp = (window.location.href.split('#')[0] === config.cancelUrl.split('#')[0]);
                            if (config.fromStartFlow || probablySinglePageApp) {
                                removePanels(config);
                            }

                            if (!config.async) {
                                // fix corner edge when hit refresh button in the browser
                                _closeWindow(app.win);
                                return redirect(window, config.cancelUrl);
                            }
                        }

                        // if no cancel or return url is passed in
                    } else if (!config.returnUrl) {
                        removePanels(config);
                        _track({
                            status: 'IC_DESTROY_NO_CANCEL_RETURN_URL'
                        });
                    }
                }

                _removeEvents();
                removePanels(config);

                isOpen = false;

                _closeWindow(app.win);

                if (config.returnUrl) {
                    _track({
                        status: 'IC_DESTROY_TO_RETURN_URL'
                    });
                    if (config.fromStartFlow && isOpen) {
                        removePanels(config);
                    }
                    if (config.async) {
                        xoEmitter.emit('return', {
                            returnUrl: config.returnUrl
                        });
                        return;
                    }

                    mask.hide();

                    if (!config.async) {
                        return redirect(window, config.returnUrl);
                    }
                }
            });

            function getCheckoutDimensions() {
                var left;
                var top;
                var width = constants.MINI_BROWSER_WIDTH;
                var height = constants.MINI_BROWSER_HEIGHT;

                if (window.outerWidth) {
                    left = Math.round((window.outerWidth - width) / 2) + window.screenX;
                    top = Math.round((window.outerHeight - height) / 2) + window.screenY;
                } else if (window.screen.width) {
                    left = Math.round((window.screen.width - width) / 2);
                    top = Math.round((window.screen.height - height) / 2);
                }

                return {
                    left: left,
                    top: top,
                    width: width,
                    height: height
                };
            }

            function _openMiniBrowser() {
                var loading = document.querySelector('#' + config.name + ' .ppmodal.loading');
                var dimensions = getCheckoutDimensions();
                var winOpened = false;
                var win;

                win = app.win = window.open('about:blank', config.name, 'top=' + dimensions.top + ', left=' + dimensions.left + ', width=' + dimensions.width + ', height=' + dimensions.height + ', location=1, status=1, toolbar=0, menubar=0, resizable=1, scrollbars=1');

                // (Backwards compatibility) Adding "win" to the global namespace for merchants from the past using internal APIS :|
                addToNamespace({
                    win: win
                });

                // Popup blocked case
                if (!win) {
                    _track({
                        status: 'IC_CLICK_OPEN_MB_FAILED'
                    }, true);
                    if (config.async) {
                        xoEmitter.emit('failure', {
                            error: constants.ERROR_MESSAGES.CANNOT_WRITE_TO_MINI_BROWSER
                        });
                    }
                    return window;
                    // for sync ajax case
                } else if (ecToken) {
                    _track({
                        status: 'IC_CLICK_OPEN_MB_SUCCESS_SYNC_AJAX'
                    });
                    if (config.async) {
                        xoEmitter.emit('success', {
                            token: ecToken
                        });
                    }
                }

                if (win && win.focus) {
                    win.focus();
                }

                if (loading) {
                    loading.className = 'ppmodal';
                }

                // Show the loading screen on the opened popup window till merchant does a 302 after setEC call
                try {
                    dom.injectLoadingInterstitial(win.document);
                    if (config.async) {
                        xoEmitter.emit('success', {
                            token: ecToken
                        });
                    }
                } catch (err) {
                    // For IE9 and IE10 win.document gets permission denied if win.domain is reset to a new domain
                    try {
                        // this is hacky and should be replaced by something better asap
                        var docDomHax = 'javascript' + ':' + 'void((function(){document.open();document.domain="' + document.domain + '";})())';
                        win.location = docDomHax;
                        dom.injectLoadingInterstitial(win.document);
                        if (config.async) {
                            xoEmitter.emit('success', {
                                token: ecToken
                            });
                        }
                    } catch (e) {
                        _log(constants.ERROR_MESSAGES.CANNOT_WRITE_TO_MINI_BROWSER);

                        // since we could not communicate with the window, we will close it
                        // otherwise it will sit there staring our user with it's about:blank stare
                        // don't fire destroy when we close the window
                        clearInterval(app.intVal);
                        // incase destroy is queued we don't want it to go anywhere.
                        // @todo: this could be abstracted into some kind of manager since
                        // there are other exit conditions now stacking up.
                        app.windowAccessCrash = true;
                        win.close();
                        if (config.async) {
                            xoEmitter.emit('failure', {
                                error: constants.ERROR_MESSAGES.CANNOT_WRITE_TO_MINI_BROWSER
                            });
                        }
                    }
                }

                winOpened = true;

                if (winOpened) {
                    var initUrl = win.location.href;

                    app.heartbeat = setTimeout(function pollMiniBrowser() {
                        if (win) {
                            // Polling minibrowser to detect if window is close, if closed redirect the parent window to return/cancel url
                            try {
                                if (win.closed) {
                                    winOpened = false;
                                    config.popupOpened = false;
                                    if (app.heartbeat) {
                                        clearTimeout(app.heartbeat);
                                        app.heartbeat = undefined;
                                        return _destroy();
                                    }
                                } else {
                                    // when mb is opened, check whether merchant site page is loaded in mb
                                    try {
                                        var currentUrl = win.location.href;
                                        // Skip checking if current url is undefined, empty string '', or 'about:blank'
                                        var isDifferentInitUrl = !!currentUrl && (initUrl !== currentUrl) && (currentUrl.indexOf('about:blank') === -1);
                                        // Skip checking if merchant service url is not defined in html (mostly ajax case)
                                        var isNotMerchantServiceUrlWhenPassed = (!merchantServiceUrl || currentUrl.indexOf(merchantServiceUrl) !== 0);
                                        // In case that paypal.com is the merchant or somehow the current page is the paypal checkout page
                                        var isPayPalCheckoutPage = (/paypal\.com(.)+token=/gi).test(currentUrl);

                                        if (isDifferentInitUrl && isNotMerchantServiceUrlWhenPassed && !isPayPalCheckoutPage) {
                                            // merchant (not initial or service to call setec) page is loaded in mb
                                            _track({
                                                status: 'IC_MERCHANT_PAGE_LOADED_IN_MINIBROWSER'
                                            });
                                            winOpened = false;
                                            _destroy();
                                            if (config.async) {
                                                xoEmitter.emit('failure', {
                                                    error: 'IC_MERCHANT_PAGE_LOADED_IN_MINIBROWSER'
                                                });
                                            }

                                            redirect(window, currentUrl);

                                            return;
                                        }
                                    } catch (e) {
                                        // showing non merchant site page, reset initUrl in case the new merchant page url
                                        // loaded in mb is the same as the initial one
                                        initUrl = null;
                                    }
                                    if (app.heartbeat) {
                                        clearTimeout(app.heartbeat);
                                        app.heartbeat = setTimeout(pollMiniBrowser, 500);
                                    }
                                }

                            } catch (err) {
                                // ie error
                                _track({
                                    status: 'IC_WINDOW_ACCESS_DENIED'
                                }, true);
                            }
                        }

                    }, 500);
                }

                return win;
            }

            function _focus() {
                if (app.win && app.win.focus) {
                    app.win.focus();
                }

                postRobot.send(app.win || config.name + 'frame', 'focus', function(err) {
                    if (err) {
                        if (app.win && app.win.focus) {
                            app.win.focus();
                        }
                    }
                });
            }

            /**
             * Sets up the events for an instance
             */
            function _bindEvents() {
                var masque = document.getElementById('ppICMask');
                var maskMessaging = document.getElementById('ppICModal');
                var closeButton = document.getElementById('closeButton');
                var continueButton = document.getElementById('ppICContinue');

                var isButtonKey = function(event) {
                    return (event.keyCode === 13 || event.keyCode === 32);
                };

                var _hustleAndFlow = function(event) {
                    // focus on click, or if continue button, focus on spacebar/enter keys
                    if (event.target !== continueButton || isButtonKey(event)) {
                        _focus();
                        paypal.checkout.startFlow();
                    }
                };

                var _keyboardDestroy = function(event) {
                    if (isButtonKey(event)) {
                        _destroy();
                    }
                };

                blocker.init({
                    container: 'ppICModal',
                    continue: 'ppbutton',
                    close: 'closeButton'
                });

                if (masque) {
                    blocker.block();
                    listeners.push(listen(masque, 'click', _hustleAndFlow));
                }

                if (maskMessaging) {
                    listeners.push(listen(maskMessaging, 'click', _hustleAndFlow));
                    listeners.push(listen(continueButton, 'keyup', _hustleAndFlow));
                }

                if (closeButton) {
                    listeners.push(listen(closeButton, 'click', _destroy));
                    listeners.push(listen(closeButton, 'keyup', _keyboardDestroy));
                }

                if (window.orientation) {
                    listeners.push(listen(window, 'orientationchange', mask.create));
                }
                listeners.push(listen(window, 'resize', mask.create));
                listeners.push(listen(window, 'unload', _destroy));
                listeners.push(listen(window, 'keyup', lightbox.toggle(_destroy)));
            }

            function _cancelIfMetaKey() {
                if (window.event) {
                    // if user is holding shift, control, or command, let the link do its thing
                    if (event.ctrlKey || event.shiftKey || event.metaKey) {
                        _track({
                            status: 'IC_RENDER_META_KEYPRESS'
                        });
                        return null;
                    }
                }
            }

            /**
             * Renders and displays the UI
             *
             * @return {object} The new popup window object the flow will appear in.
             */
            function _render() {
                try {
                    var elem = window.event ?
                        window.event.currentTarget || window.event.target || window.event.srcElement : this;

                    _cancelIfMetaKey();

                    // PXP decision return not to show in-context flow
                    if (config.showMiniB === false) {
                        return null;
                    }

                    if (elem && elem.form) {
                        elem.form.target = config.name;
                        merchantServiceUrl = elem.form.action;
                    } else if (elem && elem.tagName && elem.tagName.toLowerCase() === 'a') {
                        elem.target = config.name;
                        merchantServiceUrl = elem.href;
                    } else if (elem && elem.tagName && (elem.tagName.toLowerCase() === 'img' || elem.tagName.toLowerCase() === 'button') && elem.parentNode.tagName.toLowerCase() === 'a') {
                        elem.parentNode.target = config.name;
                        merchantServiceUrl = elem.parentNode.href;
                    } else if (elem && elem.tagName && elem.tagName.toLowerCase() === 'button' && elem.parentNode.parentNode.tagName.toLowerCase() === 'a') {
                        elem.parentNode.parentNode.target = config.name;
                        merchantServiceUrl = elem.parentNode.parentNode.href;
                    } else if (this && this.hasOwnProperty('target') && typeof this.target !== 'undefined') { // not sure what this use case is
                        this.target = config.name;
                        merchantServiceUrl = this.action || this.href;
                    }

                    // Add PayPal specific css on the merchant site
                    css.add(document, config);

                    // If PayPal mask is not present only
                    if (lightbox.isEnabled(config)) {
                        app.lightbox = lightbox.build(config);
                        setTimeout(function() {
                            app.lightbox.panel.className += ' bounceInUp';

                            config.lightboxOpened = true;
                            config.popupOpened = false;
                        }, 300);
                    } else if (!document.querySelectorAll('#' + config.name).length) {
                        dom.injectIncontext(null, config);

                        _clearBodyIframeClass(config.name);

                        mask.create();
                        // _bindEvents();

                        config.lightboxOpened = false;
                        config.popupOpened = true;
                    }

                    _bindEvents();

                    isOpen = true;

                    return _openMiniBrowser();
                } catch (err) {
                    _track({
                        status: 'IC_RENDER_ERROR',
                        error_msg: err
                    }, true);
                    errMsg = err;
                }
            }



            function _clickHandler(event, clickFn, condFn) {
                if (condFn && !condFn()) {
                    return null;
                }

                if (clickFn) {
                    clickFn(event);
                } else {
                    _render.call(this, event);
                }
            }

            /*
             * Adds click event listeners
             */
            function _setTrigger(el, clickFn, condiFn) {
                if (el) {
                    listen(el, 'click', function(event) {
                        _clickHandler.call(this, event, clickFn, condiFn);
                    });
                }
            }

            /*
             * Finds elements with data-paypal-button data attributes and adds click event listeners
             */
            function _setTriggers() {
                var i = btnList.length;

                while (i--) {
                    var btnObj = btnList[i];
                    _setTrigger(btnObj.element, btnObj.clickFn, btnObj.condFn);
                }
            }

            /**
              * Send close event to an iframe when user closes lightbox/miniBrowser / returns back to the merchant
              * Note: miniBrowser doesn't send a close message back to the parent,
              * so no need of postRobot.on('close'). Also miniBrowser sends back an error if CAN_CLOSE_SELF set to false,
              * but all we need is just destroy the window.
              * @param {string} Mini browser name, e.g PPFrameac5f5777
              */
            function _sendCloseEvent(name) {
                postRobot.send(name + 'frame', 'close', function() {
                    _destroy();
                });
            }

            function _onCancel(err, data) {
                if (!err) {
                    config.cancelUrl = (data.url || config.cancelUrl || '').replace(/&amp;/g, '&');
                    _sendCloseEvent(config.name);
                }
            }

            function _onReturn(err, data) {
                if (!err) {
                    config.returnUrl = (data.url || config.returnUrl || '').replace(/&amp;/g, '&');
                    _sendCloseEvent(config.name);
                }
            }

            function _onPostRobotInit (err, data) {
                if (!err) {
                    var secureWindowMessage = data && data.secureWindowmsg;
                    var messageContainer = document.querySelector('#' + config.name + ' .message');

                    if (secureWindowMessage) {
                        config.secureWindow = secureWindowMessage;

                        if (messageContainer) {
                            messageContainer.innerHTML = secureWindowMessage;
                            messageContainer.getElementsByClassName('ppbutton')[0].tabIndex = 1;
                        }
                    }

                    var dimensions = getCheckoutDimensions();

                    return {
                        id: config.guid,
                        dimensions: {
                            top: dimensions.top,
                            left: dimensions.left,
                            width: dimensions.width,
                            height: dimensions.height
                        }
                    };
                }
            }

            function _onPopupOpened (err, data) {
                if (!err) {
                    var masque = document.getElementsByClassName('mask')[0];

                    // 1. Render the mask w/ messaging
                    dom.injectIncontext(null, config);

                    // 2. Hide the lightbox
                    document.getElementById('PPPanel').className = '';

                    // 3. Hide the lightbox mask
                    if (masque) {
                        masque.parentNode.removeChild(masque);
                    }

                    // 4. Bind events (click events to re-focus, etc.)
                    _bindEvents();

                    // 5. Stateful flag for "is the popup opened", used all over the place
                    isOpen = true;

                    // 6. Stateful flags for "is the lightbox enabled", we're forcing the popup from here on...
                    config.oneTouchEnabled = false;
                    config.popupOpened = true;
                }
            }

            function _setupPostRobotHandler() {
                // Pass down config into the iframe when requested
                postRobot.on('init', _onPostRobotInit);

                // User closed browser -- clean up, hide overlay, and go to cancel url
                postRobot.on('cancel', _onCancel);

                // User completed checkout, so destroy the popup/lightbox and redirect to the return url
                postRobot.on('return', _onReturn);

                // Popup was opened -- show overlay
                postRobot.on('popup_opened', _onPopupOpened);
            }

            function _injectOneTouch(data) {
                if (data.popupHtml) {
                    var taglineSpans = document.getElementsByClassName(constants.JS_BUTTON_TAGLINE_SPAN_STYLE);

                    for (var i = 0; i < taglineSpans.length; i++) {
                        taglineSpans[i].innerHTML = data.popupHtml;
                    }

                    // track one touch rendering event
                    if (taglineSpans.length > 0) {
                        oneTouchShowed = true;
                        // Special tracking for one touch
                        _track({
                            'status': 'IC_RENDER'
                        });
                    }
                }

                // Inject CSS in the <head>
                if (data.popupCss) {
                    var styleEl = document.createElement('style');

                    styleEl.type = 'text/css';

                    if (styleEl.stylesheet) {
                        styleEl.stylesheet.cssText = data.popupCss;
                    } else {
                        styleEl.appendChild(document.createTextNode(data.popupCss));
                    }

                    document.getElementsByTagName('head')[0].appendChild(styleEl);
                }
            }

            function _setupPostMessageHandler() {
                var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
                var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
                var eventer = window[eventMethod];

                var msg = document.querySelector('#' + config.name + ' .message');
                var data;

                // Browsers that support postMessage
                if (window.postMessage) {
                    eventer(messageEvent, function(event) {
                        // Domain check to accept post messages from PayPal domain only or in dev mode
                        if (event.origin.match(/paypalobjects\.com/i) || event.origin.match(/paypal\.com/i) || config.devMode || event.origin.match(/localhost:8100/i)) {
                            try {
                                data = JSON.parse(event.data);
                            } catch (e) {
                                data = event.data;
                            }

                            // Normalizing URLs
                            config.returnUrl = (data.returnUrl || config.returnUrl || '').replace(/&amp;/g, '&');
                            config.landingUrl = (data.landingUrl || config.landingUrl || '').replace(/&amp;/g, '&');
                            config.cancelUrl = (data.cancelUrl || config.cancelUrl || '').replace(/&amp;/g, '&');

                            // Specific operations
                            var operation = data.operation;

                            // If a browser supports third-party cookies.
                            if (operation === 'cookie_check' && data.enabled) {
                                config.thirdPartyCookiesEnabled = true;
                            }

                            // For lightbox resizing
                            if (operation === 'lightbox_resize') {
                                app.lightbox.iframe.style.height = data.height + 'px';
                                app.lightbox.iframe.style.width = data.width + 'px';
                                app.lightbox.panel.style.height = data.height + 'px';
                                app.lightbox.panel.style.width = data.width + 'px';
                                app.lightbox.panel.style.marginTop = -(data.height / 2) + 'px';
                            }

                            _injectOneTouch(data);

                            // An app wants to destroy the mini-browser or lightbox and redirect to returnUrl
                            if (data.updateParent && config.returnUrl) {
                                if (msg) {
                                    msg.innerHTML = constants.CONTENT_LOADING;
                                }

                                data.cancelUrl = null;

                                if (config.lightboxOpened && config.popupOpened) {
                                    _sendCloseEvent(config.name);
                                } else {
                                    _destroy();
                                }
                            }

                            // If an EC token wasn't distinctly set, grab it from the landingUrl
                            if (!ecToken && config.landingUrl) {
                                ecToken = getECToken(config.landingUrl);

                                // logging for non-ajax case
                                _track({
                                    status: 'IC_CLICK_OPEN_MB_SUCCESS_NON_AJAX'
                                });
                            }

                            config.content = config.content || {};
                        }
                    });
                } else {
                    _log(constants.ERROR_MESSAGES.POSTMESSAGE_INVALID_ORIGIN);
                }
            }

            function getUrlPrefix() {
                if (config.urlPrefix) {
                    return config.urlPrefix;
                } else if (config.sandBox) {
                    return constants.SANDBOX_URL_PREFIX;
                } else {
                    return constants.LIVE_URL_PREFIX;
                }
            }

            /**
             * Detects if the browser is MiniBrowser eligible.
             * @param {none}
             * @returns {boolean} true if eligible
             */
            function _isICEligible() {
                var userAgent = navigator.userAgent.toLowerCase();

                config.isSmartPhone = device.isDevice(userAgent);
                config.isWebView = device.isWebView(userAgent);

                if (typeof config.currentAgent === 'object' && config.currentAgent.length === 2) {
                    if (parseFloat(config.currentAgent[1]) < constants.SUPPORTED_AGENTS[config.currentAgent[0]]) {
                        _track({
                            status: 'IC_ELIGIBLITY_BROWSER_NOT_SUPPORTED',
                            browser: config.currentAgent[0],
                            browserversion: config.currentAgent[1]
                        });
                        return false;
                    }
                }

                return !(config.isSmartPhone || config.isWebView || config.oldIe);
            }

            /**
             * Renders the initial checkout flow on the page
             * Basically an init function
             */
            function _init() {
                window.name = window.name === config.name ? '' : window.name;

                var gOldOnError = window.onerror;
                // Override previous handler.
                window.onerror = function errorHandler(errorMsg, url, lineNumber, columnNumber, err) {
                    var message = (err && err.message) ? err.message : errorMsg;
                    if (config.debug === 'true') {
                        _track({
                            status: 'IC_WINDOW_ERROR',
                            errmsg: message,
                            url: url
                        }, true);
                    }

                    if (gOldOnError) {
                        return gOldOnError(errorMsg, url, lineNumber, columnNumber, err);
                    }
                    return false;
                };

                // Add event listeners to PayPal trigger elements
                _setTriggers();

                // Do nothing if the device/browser is not eligible for in-context experience
                if (!_isICEligible()) {
                    config.showMiniB = false;
                    return;
                }

                var iframes = new IframeFactory(_track);

                if (config.needsIframeBridge) {
                    // SetUp PayPal Bridge
                    iframes.bridge(config);
                }

                // Setup a handler for all postMessage events for all incontext use cases
                _setupPostMessageHandler();

                // Setup handlers for post robot lifecycle events (init, popup opened, return, closed, etc.)
                _setupPostRobotHandler();

                // Determine if a user is eligible for the lightbox (fully logged in or onetouch enabled)
                lightbox.isEligible(config);

                // Determine if third-party cookies are enabled (for lightbox)
                iframes.thirdParty(config);

                // Setup prefetch iframe
                iframes.prefetch(config);
            }

            /**
             *   Create Javascript buttons if needed based on merchant's setup and then initialize
             */
            function _initWithButtonGeneration() {
                btnList = buttonGenerator(config, jsBtnConfigs, btnList);

                _track({
                    status: 'IC_SETUP',
                    'button-type': config.button ? 'STATIC' : 'JS',
                    'button-number': btnList.length
                });

                _init();

                // to ensure users not able to click static buttons before script is loaded
                var hideBtns = document.querySelectorAll('.' + constants.STATIC_BUTTON_HIDDEN_STYLE);
                var hideBtnsLength = hideBtns.length;
                for (var k = 0; k < hideBtnsLength; k++) {
                    hideBtns[k].className = hideBtns[k].className.replace(constants.STATIC_BUTTON_HIDDEN_STYLE, '');
                }
            }

            function _requireLoadButtonJS() {
                if (window.paypal.button && window.paypal.button.create) { // eslint-disable-line no-undef
                    return false;
                }

                var merchantConfig = config.merchantConfig,
                    btnListConfig = merchantConfig.buttons;

                if (btnListConfig && btnListConfig.length) {
                    for (var i in btnListConfig) {
                        if (btnListConfig[i].container) {
                            return true;
                        }
                    }
                } else if (merchantConfig && merchantConfig.container) {
                    return true;
                }

                return false;
            }

            function _checkConditionAndLog(testValue, errorValue, errorStatus) {
                var verdict = (testValue === errorValue);
                if (verdict) {
                    _log(constants.ERROR_MESSAGES[errorStatus]);
                    _track({
                        status: errorStatus,
                        error_msg: constants.ERROR_MESSAGES[errorStatus]
                    });
                }
                return verdict;
            }



            /** PUBLIC **/
            // paypal.checkout.setup(merchant, {
            //    container: 'myContainer',          // {String|HTMLElement|Array} Optional. `submit` and `click` events are hijacked when possible.
            //    button: 'myButton',                // {String|HTMLElement|Array} Optional. HTMLElement/ID of a custom buttom.
            //    locale: 'en_US',                   // {String} Optional. Local code for localization. Defaults to 'en_US'
            //    environment: 'production',         // {String} Optional. Defaults to 'production'. Possible options are 'sandbox'.
            //    app: 'hermes'                      // {String} Optional. Defaults to 'hermes'.  Possible options are 'xoonboarding'.
            //    click: function() {}               // {Function} Optional. Overrides the behavior when the button is clicked.
            //    condition: function() {}          // {Function} Optional. Boolean if the PayPal popup should when button is clicked.
            // });
            app.setup = function(merchantId, merchantConfig) {
                // allow passing just an object in,
                // use merchantID option if passed in config
                if (!merchantConfig && typeof merchantId === 'object') {
                    merchantConfig = merchantId;
                    merchantId = merchantConfig.merchantID;
                }

                // update constants with app name specified
                var configApp = merchantConfig.app || constants.APP;
                for (var key in constants) {
                    if (constants.hasOwnProperty(key) && constants[key].indexOf && constants[key].indexOf('{{app}}') > -1) {
                        constants[key] = constants[key].replace('{{app}}', configApp);
                    }
                }

                if (_checkConditionAndLog(setupCalled, true, 'IC_SETUP_CALLED_TWICE')) {
                    return;
                }

                config.guid = guid.getGUID();
                config.frameGuid = config.guid.substring(0, 8);
                config.name += config.frameGuid;
                config.merchantID = merchantId;
                config.locale = merchantConfig.locale || config.locale;
                config.async = !!merchantConfig.async;

                config.bridgeUrl = merchantConfig.bridgeUrl;
                config.domain = merchantConfig.domain;

                if (_checkConditionAndLog(!merchantId, true, 'IC_SETUP_MERCHANTID_ERROR')) {
                    return;
                }

                config.merchantConfig = merchantConfig;
                config.sandBox = merchantConfig.environment === 'sandbox' ? true : false;
                config.forceLightboxDisabled = merchantConfig.forceLightboxDisabled;

                if (config.sandBox) {
                    _log(constants.ERROR_MESSAGES.SANDBOX_BANNER);
                }

                app.urlPrefix = getUrlPrefix();

                // (Backwards compatibility) Adding "urlPrefix" to the global namespace for merchants from the past using internal APIS :|
                addToNamespace({
                    urlPrefix: app.urlPrefix,
                    events: xoEmitter
                });

                requireBtnJs = _requireLoadButtonJS();

                if (requireBtnJs) {
                    // fetch button.js
                    loadScript(constants.BUTTON_JS_URL, _initWithButtonGeneration);
                } else {
                    _initWithButtonGeneration();
                }

                // init mask
                mask = new Mask(config.name);

                // note that setup was called
                setupCalled = true;
            };

            /**
             * Public method to init the XO flow manually for ASYNC AJAX flow
             * This method need to be called before AJAX call is being made on merchant site
             * @param {null}
             */
            app.initXO = function() {
                // For non IC eligible browsers load the url in the same window
                if (!_isICEligible() || !config.showMiniB) {
                    return;
                }
                _checkConditionAndLog(setupCalled, false, 'IC_INITXO_CALLED_BEFORE_SETUP');
                config.win = _render();
            };

            /**
             * Public method to start the flow manually, e.g. from Flash
             * @param {string} url or token of the landing page that needs to be loaded in mini browser
             */
            app.startFlow = function(url, opts) {
                _checkConditionAndLog(setupCalled, false, 'IC_STARTFLOW_CALLED_BEFORE_SETUP');
                ownPropertyShim();

                if (!url || typeof url === 'object') {
                    // if mini browser already opens and url is not passed or caused by clicking on mask, then it is a restart
                    return;
                }

                // allow override of config options when flow is started
                // does this need to be guarded at all? only set config
                // options originally in merchantConfig?
                if (opts) {
                    for (var key in opts) {
                        if (opts.hasOwnProperty(key)) {
                            config[key] = opts[key];
                        }
                    }
                }

                url = url || config.landingUrl;

                // url can be either an url or token
                // if token is passed in
                if (url && url.toLowerCase && url.toLowerCase().indexOf('ec-') === 0) {
                    url = app.urlPrefix + url;
                }

                if (url && url.match(/\.paypal\.com/i)) {
                    config.fromStartFlow = true;
                }

                if (url) {
                    url = url.replace(/\s+$/, '');
                }

                try {
                    ecToken = getECToken(url);
                } catch (err) {
                    _log(constants.ERROR_MESSAGES.MISSING_EC_TOKEN);
                }

                // For non IC eligible browsers load the url in the same window
                if (!_isICEligible() || !config.showMiniB) {
                    if (url) {
                        location.href = url;
                    } else {
                        window.name = config.name;
                    }
                    return;
                }

                var win = config.win || _render();

                // If Mini browser is blocked by popup blocker assign the user to full context as fallback (legacy integrations)
                win = win || window;

                // If already Mini browser window is opened and changing the name in cross domain throws permission denied exception
                try {
                    // only name the window if the win is not full context
                    // otherwise apps will detect they are incontext
                    if (win !== window) {
                        win.name = win.name || config.name;
                    }
                } catch (err) {
                    _log(constants.ERROR_MESSAGES.MINI_BROWSER_ALREADY_OPEN);
                }

                if (url) {
                    // only do this if url present and matching pp.
                    if (url.match(/\.paypal\.com/i)) {
                        if (config.prefetchLoaded) {
                            url += '&prefetch=1';
                        }
                        if (config.cookieCheckLoaded) {
                            url += '&cookie_check=1';
                        }
                    }
                    if (win.location) {
                        win.location = url;
                    } else {
                        win.src = url;
                    }
                }

                // for async ajax case.
                if (config.win) {
                    _track({
                        status: 'IC_CLICK_OPEN_MB_SUCCESS_ASYNC_AJAX'
                    });
                }
            };

            /**
             * Public method to close the flow's UI
             */
            app.closeFlow = function(successUrl) {
                _destroy();
                if (successUrl) {
                    top.location.href = successUrl;
                }
            };

            // Return public methods
            return app;
        }());

        // Expose global namespace
        addToNamespace({
            initXO: paypal.checkout.initXO,
            startFlow: paypal.checkout.startFlow,
            closeFlow: paypal.checkout.closeFlow,
            restartFlow: paypal.checkout.startFlow,
            setup: paypal.checkout.setup
        });

        // If the merchant defined a paypalCheckoutReady function,
        // set it to run after window load
        ready(function() {
            if (typeof window.paypalCheckoutReady === 'function') {
                window.paypalCheckoutReady();
            }
        });

    }());

}());



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/checkout.js
 ** module id = 1
 ** module chunks = 0
 **/